/**
 * Espelha CriarVendaOcorrenciaRequest do OrquestradorVendas: anotação do usuário no histórico da
 * venda. O documento vai na rota; tipo, origem e usuário são postos pelo servidor.
 */
export class CriarVendaOcorrenciaRequest {
    /** Texto do usuário, até 1000 caracteres. */
    descricao: string;
    /** Data do fato, sem futuro; ausente = agora. */
    dataOcorrencia: Date | null = null;
}
